import React from 'react';

import {
  DescriptionItem,
  DescriptionList,
  Link,
  Paper,
  Typography,
} from '@gogame/components';

import EventDetails from 'scenes/Events/components/EventDetails';
import { permission as EventPermissions } from 'scenes/Events/constants';

import YesNo from './YesNo';
import { useUserPages } from 'Auth';

export default ({ data, openChildComponent }) => {
  const pages = useUserPages();
  const hasAccessToEvents = pages.includes(EventPermissions) && !!data.event.id;

  const handleOpenEvent = () => {
    openChildComponent(EventDetails, {
      id: data.event.id,
    });
  };
  return {
    color: 'info',
    date: data.eventCompletionDate,
    title: (
      <Typography>
        <span>Event - </span>
        {hasAccessToEvents ? (
          <Link onClick={handleOpenEvent}>{data.event.name}</Link>
        ) : (
          <span>{data.event.name}</span>
        )}
      </Typography>
    ),
    content: (
      <Paper
        sx={{ padding: 2, marginTop: 1, width: '100%' }}
        variant={'outlined'}
        elevation={0}
      >
        <DescriptionList
          termWidth={'200px'}
          data={data}
          disableGutters={true}
          stripEmpty={true}
        >
          <DescriptionItem
            label={'Event ID'}
            field={'event.id'}
            placeholder={'—'}
          />
          <DescriptionItem
            label={'Completion'}
            field={'isEventCompleted'}
            type={'status'}
            valueParser={(value) => ({ id: value })}
            statusFactory={YesNo}
          />
          <DescriptionItem
            label={'Completion real country'}
            field={'eventCompletionRealCountry'}
            placeholder={'—'}
          />
        </DescriptionList>
      </Paper>
    ),
  };
};
